export default __webpack_public_path__ + "static/About_us_Objective_Icon1-6288d78255e59a11afb621c725444cad.png";